import React, { useEffect, useState } from 'react';
import logo from '../assets/logo/logotransparent.png';
import '../styles/Footer.css';

function Footer() {
  const [email, setEmail] = useState('');
  const [isSubscribed, setIsSubscribed] = useState(false);

  useEffect(() => {
    const savedEmail = localStorage.getItem('footerSubscribedEmail');
    if (savedEmail) {
      setEmail(savedEmail);
      setIsSubscribed(true);
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    localStorage.setItem('footerSubscribedEmail', email.trim());
    setIsSubscribed(true);
  };

  return (
    <footer className="footer">
      <div className="footer-inner">

        {/* Col 1: Logo + Info */}
        <div className="footer-col footer-brand">
          <a href="/" target="_blank" rel="noopener noreferrer">
            <img src={logo} alt="Datamatics Consulting" className="footer-logo" />
          </a>
          <div className="footer-company-info">
            <p>Datamatics Consulting</p>
            <a href="mailto:info@datamaticsconsulting.com">
              info@datamaticsconsulting.com
            </a>
          </div>

          {/* LinkedIn Button - Fixed */}
          <a
            href="https://www.linkedin.com/company/datamatics-consulting/"
            target="_blank"
            rel="noreferrer"
            className="linkedin-btn"
            aria-label="LinkedIn"
          >
            <svg viewBox="0 0 24 24" fill="#0a66c2" xmlns="http://www.w3.org/2000/svg">
              <path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z" />
              <circle cx="4" cy="4" r="2" />
            </svg>
          </a>
        </div>

        {/* Col 2: Quick Links */}
        <div className="footer-col">
          <h4 className="footer-col-title">Quick Links</h4>
          <div className="footer-divider" />
          <div className="footer-links">
            <p><a href="/about-us" target="_blank" rel="noopener noreferrer">About Us</a></p>
            <p><a href="/contact" target="_blank" rel="noopener noreferrer">Contact Us</a></p>
          </div>
        </div>

        {/* Col 3: Main Menu */}
        <div className="footer-col">
          <h4 className="footer-col-title">Main Menu</h4>
          <div className="footer-divider" />
          <div className="footer-links">
            <p><a href="/case-studies" target="_blank" rel="noopener noreferrer">Case Studies</a></p>
            <p><a href="/industries" target="_blank" rel="noopener noreferrer">Industries</a></p>
            <p><a href="/insights" target="_blank" rel="noopener noreferrer">Insights</a></p>
          </div>
        </div>

        {/* Col 4: Subscribe */}
        <div className="footer-col">
          <h4 className="footer-col-title">Subscribe</h4>
          <div className="footer-divider" />
          <p className="subscribe-text">
            Sign up to stay up to date with all of the latest news and updates from Datamatics.
          </p>
          <form className="subscribe-form" onSubmit={handleSubmit}>
            <input
              type="email"
              placeholder="Email *"
              className="subscribe-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={isSubscribed}
            />
            <button type="submit" className="subscribe-btn" disabled={isSubscribed}>
              {isSubscribed ? 'Subscribed' : 'Submit'}
            </button>
          </form>
          {isSubscribed && (
            <div className="subscribe-success">
              <span className="subscribe-success-icon">✓</span>
              <span>Subscribed</span>
            </div>
          )}
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <span className="footer-copy">
          © 2026 Datamatics Consulting | All Rights Reserved.
        </span>
        <div className="footer-bottom-right">
          {/* <Link to="/privacy">Privacy</Link> */}
          {/* <Link to="/terms">Terms</Link> */}
          {/* <Link to="/cookies">Cookies</Link> */}
        </div>
      </div>
    </footer>
  );
}

export default Footer;